import { Directive } from '../decorators/Directive';
import { DirectiveIf } from './if';

@Directive('[elseif]')
export class DirectiveElseIf extends DirectiveIf {


                    static ρAnn(): any {
                        return {"name":"DirectiveElseIf","params":{}};
                    }
               }
